export default "/assets/images/mila-feed-03-thumbnail.a86eb58487f05b1a.jpg";